import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { Observable } from 'rxjs';
import { LinkedQuoteDto } from '@ups/xplat/api/dto';

const GET_LINKED_QUOTE = '/api/timekeeping/linked-quote/{:jobID}';

/**
 * Reads the active Quote Log entry linked to a SPARTA job (#34126, Req 2 of
 * #30672) for the "View linked Quote" link on the timekeeping job view. The
 * Sparta API returns no content when the job has no active linked quote, so the
 * observable emits null and the caller renders no link. Read-only; kept in its
 * own small service so the 1000+ line timekeeping-service stays untouched.
 */
@Injectable({ providedIn: 'root' })
export class JobLinkedQuoteService {
  private spartaClient: HttpClient;

  constructor(private clientFactory: MyHttpClientFactory) {
    this.spartaClient = this.clientFactory.createHttpClient(
      environment.urls.spartaAPI,
      true,
      ResponseCasingEnum.PascalCase
    );
  }

  public getLinkedQuoteForJob(jobID: string): Observable<LinkedQuoteDto> {
    const url = GET_LINKED_QUOTE.split('{:jobID}').join(jobID);
    return this.spartaClient.get<LinkedQuoteDto>(url);
  }
}
